import React from "react";

export default class A extends React.Component {
  componentWillMount() {
    const { history, params } = this.props;
    history.push("/");
    fetch(
      `https://us-central1-project-1029735015520686877.cloudfunctions.net/updateAffiliateClicks?aid=${
        params.aid
      }`,
      { mode: "no-cors" }
    ).then(() => {
      localStorage.setItem(
        "ghastaffiliate",
        JSON.stringify({
          aid: params.aid,
          expiresAt: this.nextMonth()
        })
      );
    });
  }

  nextMonth() {
    const today = new Date();
    const nextmonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 30
    );
    return nextmonth.getTime();
  }

  render() {
    return null;
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/pages/a/index.js
 **/